export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/constant.js
// module id = 1650
// module chunks = 0